<template>
  <v-row >
    <v-col v-if="colextra==false" cols-12 md-6 >

      <div class="my-2">  
        <div v-for="col in meta.columns" :key="col">
          <base-geo-cell v-if = "col.fieldname === 'species'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
        </div>
      </div>
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'location'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>
      <v-sheet class="d-flex flex-wrap mb-2">
        <v-sheet style="min-width: 110px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'coordinates'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div> 
        </v-sheet>
        <v-sheet style="min-width: 300px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'precision'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div>
        </v-sheet>
        <v-sheet style="min-width: 300px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'alt'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div>
        </v-sheet>
      </v-sheet>
      <v-sheet class="d-flex flex-wrap mb-2">
        <v-sheet style="min-width: 300px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'legnum'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div>
        </v-sheet>
        <v-sheet style="min-width: 300px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'legname2'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div> 
        </v-sheet>
        <v-sheet style="min-width: 300px; max-width: 100%;" class="mr-1">
          <div v-for="col in meta.columns" :key="col">
            <base-geo-cell v-if = "col.fieldname === 'legdate'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
          </div><br>
        </v-sheet>
      </v-sheet>
<!--additional data-->
<v-sheet class="d-flex flex-wrap">
      <div v-for="col in meta.columns" :key="col">
        <v-sheet v-if = "col.description.includes('additionaldata')" class="mr-1" min-width="200">
          <base-geo-cell v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
        </v-sheet>
      </div>
    </v-sheet>
<!--additional data end -->
      <div v-for="col in meta.columns" :key="col" class="mb-1">
        <base-geo-cell v-if = "col.fieldname === 'specimen_picture'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'comments'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>
      <h2 class="text-regularlight" >Main Page</h2>
    </v-col>
<!--dialogextra columns-->
<v-col v-if="colextra==true" cols-12 md-6>
  <v-sheet v-if="dialogedecology==true" class="d-flex flex-wrap ma-2">
      <div v-for="col in meta.columns" :key="col">
        <v-sheet v-if = "col.description.includes('extradata')" class="mr-1" min-width="200">
          <base-geo-cell v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
        </v-sheet>
      </div>
    </v-sheet>

    <v-btn 
      class="my-1 ma-2"
      color="regular"
      variant="outlined"
      @click="colextra=false, dialogedecology = false"
      size="x-large"
    >Close {{tabname}}
    </v-btn>
</v-col>
  <!--end of first column-->
    <v-col  cols-12 md-6 style="min-width: 300px; max-width: 350px">
      <div class="my-2">
        <div v-for="col in meta.columns" :key="col">
          <base-geo-cell v-if = "col.fieldname === 'store'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
        </div>
      </div>
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'mainstorage'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>    	
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'currentstorage'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div> 
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'localcollnumber'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>    	
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'recieved'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div> 
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'type'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div> 
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'loan'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div> 
      <div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'doublet_data'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div> 




  <!-- extradata: -->
  <v-btn
        v-if="colextra==true"
        @click="colextra=false, dialogedecology=false" 
          class="my-1"
          variant="flat"
          color="regularlight"
          >Main page
        </v-btn><br>

        <v-btn
        v-if="dialogedecology==false"
        @click="colextra=true, dialogedecology=true, tabname='Extradata'" 
          class="my-1"
          variant="flat"
          color="regular"
          >Extradata
        </v-btn><br>
 
        <br><br><div v-for="col in meta.columns" :key="col">
        <base-geo-cell v-if = "col.fieldname === 'locationexcluded'" v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
      </div>
    </v-col>
  </v-row>
<!--dialogs:-->


</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'StandardBaseFormT',
    components: {

},

data(){ 
    return {
      dialogedecology: false,
      tabname: false,
      colextra: false,
    }
},
props:['meta', 'curentRow', 'modelValue'],
emits: ['update:modelValue'],
methods: {

},

  mounted(){

  },

})
</script>